function hexToRgb(hex: string): { r: number; g: number; b: number } | undefined {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const normalizedHexString = hex.replace(shorthandRegex, (_, r: string, g: string, b: string): string => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(normalizedHexString);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : undefined;
}

function componentToHex(c: number): string {
  const hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

function rgbToHex(r: number, g: number, b: number) {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

export const convertHexColorWithOpacity = (foregroundColor: string, backgroundColor: string, opacity = 1): string => {
  const { r, g, b } = hexToRgb(foregroundColor) ?? { r: 0, g: 0, b: 0 };
  const { r: rb, g: gb, b: bb } = hexToRgb(backgroundColor) ?? { r: 0, g: 0, b: 0 };
  const backgroundRGB = [rb, gb, bb];

  const opacityChangedColor = [r, g, b].map((colorValue, i) =>
    Math.floor((colorValue ?? 0) * opacity + backgroundRGB[i] * 1 * (1 - opacity)),
  ) as [r: number, g: number, b: number];
  return rgbToHex(...opacityChangedColor);
};
